import React from 'react';
import { STEPS_FOOTNOTE, STEPS_TITLE, steps } from '../data/halloweenKit';
export function HowItWorksSection() {
  return <section className="w-full border-y border-pumpkin/20 bg-black py-14 sm:py-16" aria-labelledby="steps-title" data-id="element-127" data-mp="fs679yymvx6l">
      <div className="mx-auto max-w-5xl px-5" data-id="element-128" data-mp="uh2b1jtnqo1e">
        <h2 id="steps-title" className="text-center font-display text-[1.75rem] font-semibold leading-tight text-cream-50 sm:text-[2.4rem]" data-id="element-129" data-mp="pj0p8r4ukam8">
          {STEPS_TITLE}
        </h2>

        <ol className="mt-9 grid gap-6 sm:grid-cols-3 sm:gap-8" data-id="element-130" data-mp="3t00xpt2nunai">
          {steps.map((s, i) => <li key={s.title} className="flex items-start gap-4 sm:flex-col sm:items-center sm:text-center" data-id="element-131" data-mp="au4nfbtdvtu2" data-mpi={i}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-pumpkin font-display text-xl font-semibold text-night-950" data-id="element-132" data-mp="6r7zr6ozl7j9">
                {i + 1}
              </span>
              <div data-id="element-133" data-mp="1i6ejuil2ou36">
                <h3 className="font-display text-[1.35rem] font-semibold leading-tight text-cream-50 sm:mt-1" data-id="element-134" data-mp="1i6wpu6xjemoa">{s.title}</h3>
                <p className="mt-1.5 text-[14.5px] leading-snug text-body" data-id="element-135" data-mp="wcz89lzijcss">{s.body}</p>
              </div>
            </li>)}
        </ol>

        <p className="mt-9 text-center text-[12.5px] leading-relaxed text-muted" data-id="element-136" data-mp="15cdz4mjldpdt">{STEPS_FOOTNOTE}</p>
      </div>
    </section>;
}